import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/updateReadyToCheckout/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showUpdateReadyToCheckoutSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showUpdateReadyToCheckoutSelector };
